import React from 'react';
import { useTranslation } from 'react-i18next';
import { ManagerLensSvg } from '../ui/manager-lens-svg';

export const ManagerMeetingsLensButton = ({onClick, title}) => {
    const { t } = useTranslation();
    return (
        <button className="meetings-lens-button" onClick={onClick}>
            <ManagerLensSvg/>
            <span>{title ?? t('Manager\'s lens')}</span>
        </button>
    )
};
